/**
 * Service for working on the url
 */

// vendors
import { Injectable } from '@angular/core';


@Injectable()
export class UrlService {
    /**
     * Parameter for presetting the amount
     * Attention: That name is already used in the EmbedController of the Symfony App
     * @type {string}
     */
    public readonly PARAMETER_AMOUNT_PRESET = "tw_amount";

    /**
     * Parameter for presetting the minimum value of the slider
     */
    public readonly PARAMETER_AMOUNT_MIN_PRESET = "tw_min";

    /**
     * Parameter for presetting the maximum value of the slider
     */
    public readonly PARAMETER_AMOUNT_MAX_PRESET = "tw_max";

    /**
     * Parameter for presetting the target
     * Attention: That name is already used in the EmbedController of the Symfony App
     * @type {string}
     */
    public readonly PARAMETER_TARGET_PRESET = "tw_target";

    /**
     * Parameter for presetting the target to a fixed value
     * @type {string}
     */
    public readonly PARAMETER_TARGET_PRESET_FIX = "tw_target_fix";

    /**
     * Parameter for presetting the target with the internal_id
     * @type {string}
     */
    public readonly PARAMETER_TARGET_ID_PRESET = "tw_target_id";

    /**
     * Parameter for presetting the target with the internal_id
     * @type {string}
     */
    public readonly PARAMETER_TARGET_ID_PRESET_FIX = "tw_target_id_fix";

    /**
     * Parameter for presetting the rhythm
     * Attention: That name is already used in the EmbedController of the Symfony App
     * @type {string}
     */
    public readonly PARAMETER_RYTHM_PRESET = "tw_rhythm";

    /**
     * Parameter for presetting the campaign
     * Attention: That name is already used in the EmbedController of the Symfony App
     * @type {string}
     */
    public readonly PARAMETER_CAMPAIGN = "tw_cid";

    /**
     * Parameter for presetting the remarks
     * @type {string}
     */
    public readonly PARAMETER_REMARKS = "tw_remarks";

    /**
     * Paramater for presetting a product in the shop.
     * The value is the ID of the item
     * @type {string}
     */
    public readonly PARAMETER_PRODUCT = "tw_product";

    /**
     * Paramater for presetting a bundle in the shop.
     * The value is the ID of the item
     * @type {string}
     */
    public readonly PARAMETER_BUNDLE = "tw_bundle";

    /**
     * Paramater for presetting a category in the shop.
     * The value is the ID of the item
     * @type {string}
     */
    public readonly PARAMETER_CATEGORY = "tw_cat";

    /**
     * Parameter to togggle that the widget is opened inside a webview/app.
     * Can be used to force the webview to open redirect payments in same window.
     */
    public readonly PARAMETER_APP = "tw_app";

    /**
     * Parmeter to show an extra thankyou text, instead of the default widget header.
     */
    public readonly PARAMETER_THANKYOU = "tw_thankyou";

    /**
     * retruns the value of a get parameter from the URL. Returns null if the parameter is not set
     *
     * @param {string} parameterName
     * @returns {string}
     */
    public findGetParameter(parameterName: string): string {
        let result = null,
            tmp = [];
        location.search
            .substr(1)
            .split("&")
            .forEach(function (item) {
                tmp = item.split("=");
                if (tmp[0] === parameterName) {
                  result = decodeURIComponent(tmp[1]);
                }
            });
        return result;
    }
}
